import TaxiCorporationUnbilledRouteListResponse, {
  TaxiCorporationUnbilledRouteListResponseData,
  TaxiCorporationUnbilledRouteListResponseDataItem,
} from "../../../../api/raily/taxi-corporation/unbilled/route-list/taxi-corporation-unbilled-route-list.response";
import TaxiCorporationUnbilledRouteList, {
  TaxiCorporationUnbilledRouteListItem,
} from "./taxi-corporation-unbilled-route-list";

const createDataItem = (
  item: TaxiCorporationUnbilledRouteListResponseDataItem,
): TaxiCorporationUnbilledRouteListItem => {
  return {
    addresses: item.addresses,
    cargoOrderHumanIds: item.cargoOrderHumanIds,
    clients: item.clients,
    driver: item.driver,
    fleetPartner: item.fleetPartner,
    humanId: item.humanId,
    startTime: item.startTime,
    uuid: item.id,
  };
};

const createDataItems = (
  items: TaxiCorporationUnbilledRouteListResponseDataItem[],
): TaxiCorporationUnbilledRouteListItem[] => {
  return items.map(createDataItem);
};

const createData = (
  data: TaxiCorporationUnbilledRouteListResponseData,
): TaxiCorporationUnbilledRouteList => {
  return {
    data: createDataItems(data.data),
    totalCount: data.totalCount,
  };
};

const create = (
  response: TaxiCorporationUnbilledRouteListResponse,
): TaxiCorporationUnbilledRouteList => {
  return createData(response.data);
};

const taxiCorporationUnbilledRouteListFactory = {
  create,
};

export default taxiCorporationUnbilledRouteListFactory;
